module.exports = __webpack_public_path__ + "img/page-not-found.00d13a0c.svg";